import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthForm from '../components/AuthForm';
import { useUser } from '../contexts/UserContext';
import { useAuthToken } from '../contexts/AuthTokenContext';
import { useAuthRouting } from '../contexts/AuthRouteContext';

export default function LoginPage() {
  const { login } = useUser();
  const { redirectPathAfterLogin, setRedirectPathAfterLogin } = useAuthRouting();
  const { token } = useAuthToken();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [externalToken, setExternalToken] = useState('');
  const [authProvider, setAuthProvider] = useState('Local');

  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password, authProvider, externalToken);
    } catch (err) {
      console.error(err);
      setError('Login failed');
    }
  };

  useEffect(() => {
    if (token) {
      const target = redirectPathAfterLogin || '/';
      setRedirectPathAfterLogin(null);
      navigate(target, { replace: true });
    }
  }, [token]);

  return (
    <AuthForm
      showSocialIcons={false}
      title="Login to Castly"
      image="/login.jpg"
      fields={[
        {
          name: 'email',
          label: 'Email',
          type: 'email',
          value: email,
          onChange: (e) => setEmail(e.target.value),
        },
        {
          name: 'password',
          label: 'Password',
          type: 'password',
          value: password,
          onChange: (e) => setPassword(e.target.value),
        },
      ]}
      onSubmit={async () => {
        const success = await login(email, password, authProvider, externalToken);
        if (!success) throw new Error("Login failed");
        return success;
      }}
      onSuccess={() => {
        navigate("/");
        console.log('Logged in');
      }}
      onFailure={(err) => {
        setError("Incorrect email or password");
      }}
      errorMessage={error}
      submitLabel="Login"
      submittingLabel="Logging in"
      footerLinks={[
        { href: '/forgot-password', label: 'Forgot password?' },
        { href: '/register', label: "Don't have an account? Register" },
      ]}
    >
      {error && <p style={{ color: 'red', marginTop: '8px' }}>{error}</p>}
    </AuthForm>
  );
}
